import { defineMessages } from 'react-intl';

export default defineMessages({
  seriesLabel: {
    id: 'series',
    description: 'series label',
    defaultMessage: 'series',
  },
  loading: {
    id: 'loading',
    description: 'loading',
    defaultMessage: 'LOADING...',
  },
  noTemplates: {
    id: 'noTemplates',
    description: 'no templates',
    defaultMessage:
      'There are currently no templates associated with this model.',
  },
});
